import React from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import HeadingValue from './common/HeadingValue';
import PageTitle from './common/PageTitle';
import { Helmet } from 'react-helmet';
import { getPartnerData, isPartnerDomain } from '../partnerDomain';


class Impressum extends React.Component {

	render() {
		const partnerData = getPartnerData();
		const onPartnerDomain = isPartnerDomain() && partnerData;

		// If on a partner domain and the partner has a custom Impressum
		if (onPartnerDomain && partnerData.impressum) {
			return (
				<>
					<Helmet>
						<title>Impressum - {partnerData.name}</title>
						<meta name="description" content={`Impressum von ${partnerData.name}`} />
						<meta name="robots" content="index, follow" />
					</Helmet>

					<PageTitle title="Impressum" />
					<section className="section pt-5 pb-5" style={{ minHeight: "600px" }}>
						<Container>
							<Row>
								<Col md={12} className="mx-auto">
									<div className="p-5 osahan-invoice bg-white shadow-sm">
										<Row className="mt-3">
											<Col md={12}>
												<div
													style={{ whiteSpace: 'pre-line' }}
													dangerouslySetInnerHTML={{ __html: partnerData.impressum }}
												/>
											</Col>
										</Row>
									</div>
								</Col>
							</Row>
						</Container>
					</section>
				</>
			);
		}

		// Default Liefershops Impressum
		return (
			<>
				<Helmet>
					<title>Impressum - Bestellen Sie Essen online Liefershops.de</title>
					<meta name="description" content="Das Impressum von Liefershops.de | S.Betz Company Ortolfstraße 172, 12524 Berlin, E-Mail: kontakt@lieferberlin.de." />
					<meta name="keywords" content="Impressum, rechtliche Informationen, Kontakt, Essen bestellen" />
					<meta property="og:title" content="Impressum - Liefershops.de S.Betz Company" />
					<meta property="og:description" content="Alle rechtlichen Informationen und Kontaktmöglichkeiten für Liefershops.de." />
					<meta property="og:type" content="website" />
					<meta name="robots" content="index, follow" />
				</Helmet>

				<PageTitle
					title="Impressum"
				/>
				<section className="section pt-5 pb-5" style={{ height: "800px" }}>
					<Container>
						<Row>
							<Col md={12} className="mx-auto">
								<div className="p-5 osahan-invoice bg-white shadow-sm">
									<Row className="mt-5">
										<Col md={12}>
											<h5 className="mb-3 text-black "><strong>S. Betz Company </strong></h5>
											<HeadingValue heading='Ortolfstraße 172 ' />
											<HeadingValue heading='12524 Berlin' />
											<HeadingValue heading='Telefon : 030/47 38 70 89' />
											<HeadingValue heading='Email : kontakt@lieferberlin.de ' />
										</Col>
									</Row>
								</div>
							</Col>
						</Row>
					</Container>
				</section>
			</>
		);
	}
}


export default Impressum;
